const KL_HOROSCOPE_COLLECTION_EVENT = 'kl:horoscope:sign';
const KL_HOROSCOPE_COLLECTION_ADDED_EVENT = 'kl:content:added';

function buildHoroscopeCollectionUrl(collectionsUrl, handle, sectionId) {
  return `${collectionsUrl}/${encodeURIComponent(handle)}?section_id=${encodeURIComponent(sectionId)}`;
}

function readHoroscopeCollectionRail(responseText) {
  const responseDocument = new DOMParser().parseFromString(responseText, 'text/html');
  const slotElement = responseDocument.querySelector('[data-kl-horoscope-collection-slot]');

  if (!slotElement) return null;

  return {
    markup: slotElement.innerHTML,
    collectionTitle: slotElement.dataset.klHoroscopeCollectionTitle || '',
  };
}

function chooseHoroscopeCollectionHeading(signHeading, collectionTitle, defaultHeading) {
  return signHeading || collectionTitle || defaultHeading;
}

function initHoroscopeCollection(rowElement) {
  const slotElement = rowElement.querySelector('[data-kl-horoscope-collection-slot]');
  const headingElement = rowElement.querySelector('[data-kl-horoscope-collection-heading]');

  if (!slotElement) return;

  const { klHoroscopeCollectionSection: sectionId, klHoroscopeCollectionUrl: collectionsUrl } =
    rowElement.dataset;

  if (!sectionId || !collectionsUrl) return;

  const defaultRail = slotElement.innerHTML;
  const defaultHeading = headingElement ? headingElement.textContent.trim() : '';
  const railCache = new Map();

  let currentHandle = '';
  let currentHeading = '';
  let abortController = null;

  function renderHeading(headingText) {
    if (!headingElement) return;

    headingElement.textContent = headingText;
  }

  function renderRail(markup) {
    slotElement.innerHTML = markup;

    document.dispatchEvent(
      new CustomEvent(KL_HOROSCOPE_COLLECTION_ADDED_EVENT, {
        detail: { root: slotElement },
      }),
    );
  }

  async function loadRail(handle, signHeading) {
    if (handle === currentHandle && signHeading === currentHeading) return;

    if (abortController) abortController.abort();

    currentHandle = handle;
    currentHeading = signHeading;

    if (handle === '') {
      renderHeading(defaultHeading);
      renderRail(defaultRail);
      return;
    }

    const cachedRail = railCache.get(handle);

    if (cachedRail) {
      renderHeading(
        chooseHoroscopeCollectionHeading(signHeading, cachedRail.collectionTitle, defaultHeading),
      );
      renderRail(cachedRail.markup);
      return;
    }

    const controller = new AbortController();

    abortController = controller;

    try {
      const response = await fetch(buildHoroscopeCollectionUrl(collectionsUrl, handle, sectionId), {
        signal: controller.signal,
      });

      if (!response.ok) throw new Error(`The collection row responded ${response.status}`);

      const fetchedRail = readHoroscopeCollectionRail(await response.text());

      if (!fetchedRail) throw new Error('The collection row returned no rail');

      railCache.set(handle, fetchedRail);

      if (currentHandle !== handle) return;

      renderHeading(
        chooseHoroscopeCollectionHeading(signHeading, fetchedRail.collectionTitle, defaultHeading),
      );
      renderRail(fetchedRail.markup);
    } catch (error) {
      if (error?.name === 'AbortError') return;

      console.debug('kl-horoscope-collection: could not load the row for this sign', {
        handle,
        error,
      });
    } finally {
      if (abortController === controller) abortController = null;
    }
  }

  document.addEventListener(KL_HOROSCOPE_COLLECTION_EVENT, (event) => {
    const handle = (event.detail && event.detail.collectionHandle) || '';
    const signHeading = (event.detail && event.detail.headingText) || '';

    loadRail(handle, signHeading);
  });
}

document.querySelectorAll('[data-kl-horoscope-collection]').forEach(initHoroscopeCollection);

document.addEventListener('shopify:section:load', (event) => {
  event.target.querySelectorAll('[data-kl-horoscope-collection]').forEach(initHoroscopeCollection);
});
